import { Button, Modal } from "antd";
import { ListingsStatsByDate, PayoutType } from "../api/models";
import moment from "moment";
import { formatCurrency } from "../utils";
import { useState } from "react";
import ListingActivityPage from "./ListingActivity";

export interface Props {
    onClose: () => void;
    venue: string;
    account: string;
    data: ListingsStatsByDate[];
}

export interface DailyBreakdown {
    date: Date;
    payoutType: PayoutType;
}

const SalesRevenueBreakdown = (props: Props) => {
    const title = "Daily Breakdown - " + props.venue + (props.account.length > 0 ? '(' + props.account + ')' : '');

    const [dailyBreakdown, setDailyBreakdown] = useState<DailyBreakdown>();

    const data = props.data.slice().reverse().filter(d => {
        return d.stats.find(s => s.venue == props.venue) != null;
    });

    return (
        <div>
            <Modal open onOk={props.onClose} onCancel={props.onClose} cancelButtonProps={{ style: { display: 'none' } }} title={title} width="800px">
                {dailyBreakdown ?
                    <div className="flex flex-col gap-2.5">
                        <div className="flex gap-2.5 items-center">
                            <Button type="primary" onClick={() => setDailyBreakdown(undefined)}>Back</Button>
                            <span className="text-sm text-text">{moment(dailyBreakdown.date).utc().format('LL')}</span>
                        </div>
                        <ListingActivityPage initialPageSize={5} source={props.venue} type="payout" dateStart={dailyBreakdown.date}
                            dateEnd={moment(dailyBreakdown.date).utc().add(1, 'day').toDate()} payoutType={dailyBreakdown.payoutType}
                            account={props.account} />
                    </div> :
                    <table className="w-full">
                        <thead>
                            <tr>
                                <th className="text-left text-2xs uppercase tracking-wider text-text-3 font-semibold py-2 px-3">Date</th>
                                <th className="text-right text-2xs uppercase tracking-wider text-text-3 font-semibold py-2 px-3">Revenue (USD)</th>
                                <th className="text-right text-2xs uppercase tracking-wider text-text-3 font-semibold py-2 px-3">Recurring ($)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((d) => {
                                const stats = d.stats.find(s => s.venue == props.venue);
                                return (
                                    <tr key={d.date.toISOString()} className="border-t border-border hover:bg-bg-elevated transition-colors">
                                        <td className="py-2 px-3 text-sm text-text">{moment(d.date).utc().format('LL')}</td>
                                        <td className="py-2 px-3 text-right">
                                            <button
                                                type="button"
                                                onClick={() => setDailyBreakdown({ date: d.date, payoutType: 'full' })}
                                                className="text-accent text-sm font-mono tabular-nums hover:opacity-80 cursor-pointer"
                                            >
                                                {formatCurrency(stats?.revenueUSD)}
                                            </button>
                                        </td>
                                        <td className="py-2 px-3 text-right">
                                            <button
                                                type="button"
                                                onClick={() => setDailyBreakdown({ date: d.date, payoutType: 'installment' })}
                                                className="text-accent text-sm font-mono tabular-nums hover:opacity-80 cursor-pointer"
                                            >
                                                {formatCurrency(stats?.recurringRevenueUSD)}
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                }
            </Modal>
        </div>
    );
};
export default SalesRevenueBreakdown;
